import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './index.module.scss';

interface Props {
  children: string;
}

const ProductTable: React.FC<Props> = (props: Props) => {
  return (
    <>
      <div className={styles.tableWrapper}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          className={styles.table}
          linkTarget='_blank'
        >
          {props.children}
        </ReactMarkdown>
      </div>
    </>
  );
};

export default ProductTable;
